/* ==========================================================================
   Moss & Pixel — theme behaviour
   Vanilla JS, no framework. Progressive enhancement: every action also works
   without JS (forms POST to Shopify, links navigate).
   ========================================================================== */
(function () {
  'use strict';

  var money = window.Shopify && window.Shopify.formatMoney ? null : null;

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* Share the cart count with the marketing site via a cookie on the shared
     parent domain (e.g. .mossandpixel.com), so its header badge stays in sync. */
  function syncCartCountCookie(count) {
    var domain = window.theme && window.theme.cartCookieDomain;
    if (!domain) return;
    var maxAge = 60 * 60 * 24 * 14; // 14 days
    document.cookie =
      'mp_cart_count=' + encodeURIComponent(count) +
      '; domain=' + domain + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  /* --------------------------------------------------------------------
     Mobile navigation toggle
     -------------------------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var iconOpen = toggle.querySelector('[data-icon-open]');
    var iconClose = toggle.querySelector('[data-icon-close]');

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'));
    });

    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) setOpen(false);
    });
  }

  /* --------------------------------------------------------------------
     Store dropdown (desktop): open on hover, toggle on click, close on Escape
     -------------------------------------------------------------------- */
  function initNavDropdown() {
    var item = document.querySelector('[data-store-item]');
    if (!item) return;
    var trigger = item.querySelector('[data-store-trigger]');

    function open() {
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    if (trigger) {
      trigger.addEventListener('click', function () {
        item.classList.contains('is-open') ? close() : open();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* --------------------------------------------------------------------
     Cart drawer + AJAX add-to-cart
     -------------------------------------------------------------------- */
  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-cart-open]');
        if (openBtn && Cart.drawer) {
          e.preventDefault();
          Cart.open();
          Cart.refresh();
        }
        if (e.target.closest('[data-cart-close]')) Cart.close();
        var remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          Cart.change(remove.getAttribute('data-line'), 0);
        }
      });

      // Product add-to-cart forms
      document.querySelectorAll('form[data-product-form]').forEach(function (form) {
        form.addEventListener('submit', Cart.onAddSubmit);
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    onAddSubmit: function (e) {
      // No drawer present → let the browser POST normally (redirect to /cart).
      if (!Cart.drawer) return;
      e.preventDefault();
      var form = e.currentTarget;
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          Cart.open();
          return Cart.refresh();
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        });
    },

    change: function (line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); });
    },

    refresh: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); return cart; });
    },

    render: function (cart) {
      // Update all cart bubbles
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      syncCartCountCookie(cart.item_count);

      var body = this.drawer && this.drawer.querySelector('[data-cart-items]');
      var subtotal = this.drawer && this.drawer.querySelector('[data-cart-subtotal]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="muted" style="padding:2rem 0;text-align:center;">Your cart is empty.</p>';
        if (subtotal) subtotal.textContent = '';
        return;
      }

      body.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + item.title + '">'
          : '';
        return (
          '<div class="cart-item">' +
            '<div class="cart-item__media">' + img + '</div>' +
            '<div>' +
              '<p class="cart-item__title">' + item.product_title + '</p>' +
              (item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
              '<p class="cart-item__variant">Qty ' + item.quantity + '</p>' +
              '<button type="button" class="cart-item__remove" data-cart-remove data-line="' + (i + 1) + '">Remove</button>' +
            '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>'
        );
      }).join('');

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }
  };

  /* --------------------------------------------------------------------
     Product variant selection + gallery
     -------------------------------------------------------------------- */
  function initProduct() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;

    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);

    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = form && form.querySelector('[data-add-btn]');
    var stockEl = root.querySelector('[data-product-stock]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[Number(group.getAttribute('data-option-index'))] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    var optionGroups = root.querySelectorAll('[data-option-index]');

    function update() {
      // Single / default-variant products have no option pickers — leave the
      // server-rendered variant id, price and button untouched.
      if (optionGroups.length === 0) return;

      var opts = selectedOptions();
      var variant = findVariant(opts);

      // reflect selected styling on pills
      root.querySelectorAll('.option-pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        pill.classList.toggle('is-selected', input && input.checked);
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In stock — ready to ship' : 'Currently sold out';
        stockEl.classList.toggle('product__stock--out', !variant.available);
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  /* --------------------------------------------------------------------
     Product image carousel — autoplay + arrows + dots + thumbs
     -------------------------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    if (!track || slides.length <= 1) return;

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var viewport = gallery.querySelector('[data-gallery-viewport]');

    var count = slides.length;
    var index = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = gallery.getAttribute('data-autoplay') === 'true' && !reduce;
    var interval = parseInt(gallery.getAttribute('data-interval'), 10) || 5000;
    var timer = null;

    function go(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
        d.setAttribute('aria-selected', di === index ? 'true' : 'false');
      });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
    }
    function nextSlide() { go(index + 1); }
    function prevSlide() { go(index - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (autoplay && !timer) { timer = setInterval(nextSlide, interval); } }
    function restart() { stop(); start(); }

    if (next) next.addEventListener('click', function () { nextSlide(); restart(); });
    if (prev) prev.addEventListener('click', function () { prevSlide(); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10)); restart(); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10)); restart(); });
    });

    // Pause on hover / focus, resume on leave
    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', start);

    // Keyboard arrows when the viewport is focused
    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); restart(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); prevSlide(); restart(); }
      });
    }

    // Reveal arrows briefly on touch (they're hidden until hovered/tapped)
    var hideControlsTimer;
    function showControls() {
      gallery.classList.add('is-controls-visible');
      clearTimeout(hideControlsTimer);
      hideControlsTimer = setTimeout(function () { gallery.classList.remove('is-controls-visible'); }, 3000);
    }

    // Touch swipe
    var startX = 0, dragging = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; dragging = true; stop(); showControls(); }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? nextSlide() : prevSlide(); }
      start();
    });

    // Pause when the tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    go(0);
    start();
  }

  /* --------------------------------------------------------------------
     Quantity steppers
     -------------------------------------------------------------------- */
  function initQuantity() {
    document.querySelectorAll('.quantity').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initNavDropdown();
    Cart.init();
    initProduct();
    initGallery();
    initQuantity();
    // Publish the server-rendered cart count to the shared cookie on first load.
    if (window.theme) syncCartCountCookie(window.theme.cartItemCount || 0);
  });
})();
